"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = require("react");
const throttle_1 = __importDefault(require("lodash/throttle"));
function useThrottledCallback(callback, { wait, trailing = true }, dependencies) {
    const throttledFunction = (0, react_1.useMemo)(() => {
        return (0, throttle_1.default)(callback, wait, { trailing });
    }, [wait, trailing, ...dependencies]);
    const throttledCallback = (0, react_1.useCallback)(throttledFunction, [throttledFunction]);
    return throttledCallback;
}
exports.default = useThrottledCallback;
